import React from "react";
import { Box } from "@mui/material";
import CustomButton from "../../../../UIElements/CustomButton";
import "../../../../components-styles.scss";
import "../../../profil-styles.scss";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import InputField from "../../../../UIElements/InputField";
import CancelModalButton from "../../../../UIElements/CustomModal/CancelModalButton";

type EditCompanyNameFormProps = {
    onSubmit: Function;
    defaultValue?: {
        companyName: string;
    };
};

const validationSchema = yup.object({
    companyName: yup.string().required("Veuillez renseigner la raison sociale"),
});

export default function EditCompanyNameForm({
    onSubmit,
    defaultValue,
}: EditCompanyNameFormProps) {
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            companyName: defaultValue?.companyName ?? "",
        },
        resolver: yupResolver(validationSchema),
    });

    const _onSubmit = (data: any) => {
        onSubmit(data);
    };

    return (
        <Box className="profil-form-root">
            <form
                onSubmit={handleSubmit(_onSubmit)}
                className="profil-form-container"
            >
                <Controller
                    name="companyName"
                    control={control}
                    render={({ field: { ref, ...others } }) => {
                        return (
                            <InputField
                                {...others}
                                label={"Nom de l'établissement *"}
                                fullWidth
                                outlinedinputsx={{
                                    border: "2px solid  #E3E6E8",
                                }}
                                errortext={
                                    errors.companyName
                                        ? errors.companyName.message
                                        : ""
                                }
                            />
                        );
                    }}
                />

                <CustomButton
                    type="submit"
                    label="Enregister"
                    customsx={{
                        width: "100%",
                    }}
                />
                <CancelModalButton
                    customsx={{
                        width: "100%",
                    }}
                />
            </form>
        </Box>
    );
}
